module.exports = __webpack_public_path__ + "img/zimibabao.4aae5409.jpg";